export default {
	title: "Spôsoby Platby",
	tips: "Vážený používateľ, prosím vyplňte svoju adresu ERC20/TRC20. Prosím, nezadávajte údaje o vašom bankovom účte a heslo",
	form: {
		TransactionPassword: "Heslo transakcie",
		Address: "Adresa Peňaženky"
	},
	label: ["Názov Banky", "Kód Pobočky", "Názov Pobočky", "Typ Vkladu", "Číslo Účtu", "Vlastník Účtu"],
	tabs: ["Banková Karta", "Sieť"],
	delete: "Odstrániť",
	default: "Predvolené",
	create: "Vytvoriť",
	type: "Typ Výberu",
	verifying: "overovanie",
	VerifyWalletAddress: "Overiť adresu peňaženky",
	defaultAccount: "Predvolený Účet na Výber",
	deleteMsg: "Ste si istí, že chcete odstrániť?"
};
